import classNames from "classnames";

import {CodeBlock} from "@/components/codeBlock/CodeBlock.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";

import styles from "./SAMLConfigLine.module.scss";
interface SSOConfigLineProps {
  tooltip: string;
  text: string;
  code: string;
  optional?: boolean;
  className?: string;
  variant?: "general" | "tab";
}

export const SAMLConfigLine = ({tooltip, code, text, optional, className, variant = "general"}: SSOConfigLineProps) => (
  <div className={classNames(className, variant ? styles[variant] : "")}>
    <dt className="mb-1 d-flex pulseTextBodySmallBold">
      <span>{text}</span>
      {optional && <span className="text-muted ms-1">(optional)</span>}
      <TooltipIconRA className="ms-1 text-muted" title={tooltip} />
    </dt>
    <dd className={classNames("text-wrap", styles.codeBlock)}>
      <CodeBlock code={code} className="p-2" codeClassName={classNames("p-0", styles.codeBlock)} />
    </dd>
  </div>
);
